import { render, staticRenderFns } from "./MakeOlympicsPredictions.vue?vue&type=template&id=4f7c452a&scoped=true&"
import script from "./MakeOlympicsPredictions.vue?vue&type=script&lang=js&"
export * from "./MakeOlympicsPredictions.vue?vue&type=script&lang=js&"
import style0 from "./MakeOlympicsPredictions.vue?vue&type=style&index=0&id=4f7c452a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7c452a",
  null
  
)

export default component.exports